import {html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {repeat} from 'lit/directives/repeat.js';
import {when} from 'lit/directives/when.js';
import {classMap} from 'lit/directives/class-map.js';
import {property} from 'lit/decorators/property.js';
import {AttributeInterpreter} from '@viamedici-spc/configurator-ts';

import {staggeredReveal} from '../../css/styleSets';
import {attributeWidget} from '../../css/attributeWidget';

import info from '../../../icons/info';
import reset from '../../../icons/reset';
import radio from '../../../icons/radio';
import radioChecked from '../../../icons/radio-checked';
import {SpcChoiceAttribute} from './spcChoiceAttribute';
import {pimText} from '../../util/values';

@customElement('spc-choice-attribute-combo')
export class SpcChoiceAttributeCombo extends SpcChoiceAttribute {

	static styles = [
		staggeredReveal,
		attributeWidget,
		css`
			:host {}
			.attribute {
				break-inside: avoid;
			}

			.values {
				display: flex;
				flex-direction: column;
				overflow-y: auto;
				height: 200px;
				flex-flow: column;
				margin-top: 2px;
				border-bottom: 1px solid var(--color-widget-border);
				padding-right: 1px;
			}
			.satisfied .values {
				height: auto;
			}

			.search {
				display: flex;
				flex-direction: column;
				border: 1px solid var(--color-widget-border);
				overflow-y: auto;
				max-height: 200px;
				padding: 0 0.5rem;
			}

			.input {
				display: block;
				font-family: var(--font-family-light);
				font-size: var(--font-size-widget);
				color: var(--color-white);
				background-color: var(--color-background-widget);
				border: 0;
				height: var(--height-widget);
				//min-height: var(--height-widget);
				line-height: 120%;
				margin: 0;
				cursor: pointer;
				width: auto;
				text-align: left;
				outline: none;
			}
		`];

	@property({type: String})
	search = '';

	constructor() {
		super();
		this.search = '';
		this.addEventListener('activate-combo', (e) => {
			this.activate();
			e.target.value = '';
		});
		this.addEventListener('deactivate-combo', (e) => {
			this.deactivate();
			e.target.value = '';
		});
		this.addEventListener('select-value', (e) => {
			e.target.value = '';
		});
	}

	stateChanged(state) {
		super.stateChanged(state);
		const selectedChoiceValueIds = AttributeInterpreter.getIncludedChoiceValues(this.attribute).map((a) => a.id);
		const selectedChoiceValueId = selectedChoiceValueIds?.[0] ?? null;
		const selectedValueText =  pimText(this.lang, this.attributeId.localId, 'FV', this.spcConfiguration, this.translations, selectedChoiceValueId, '', '', '', false);
		if (selectedValueText !== this.search) {
			this.search = selectedValueText;
		}
	}

	normalize(str) {
		return str.replace(/[\n\r\s\t]+/g, '').toLowerCase();
	}

	onInput(e) {
		const el = e.target;
		if (el.id === 'search') {
			this.search = el.value;
		}
	}

	filteredValues(values) {
		if (this.search && this.search.length > 0) {
			return [...values].filter(
				value => {
					const label = pimText(this.lang, this.attributeId.localId, 'FV', this.spcConfiguration, this.translations, value.id).toLowerCase();
					return label.indexOf(this.search.toLowerCase()) !== -1;
				}
			);
		} else {
			return values;
		}
	}
	activate(e) {
		// select content of input field
		const el = e?.target;
		el.select();
	}

	render() {
		if (!this.values) return null;
		return html`
			<div class="attribute ${classMap({satisfied: this.isSatisfied()})}">
				<div class="title">
					<span class="label">
						<trans-label key="${this.attributeId.localId}" context="F" title="${this.attributeId.localId}"></trans-label>
					</span>
					<div class="tools">
						${when(this.hasFeatureDescription(), () => html`
							<button class='tools_button' @click="${this.openModal}">${info}</button>
						`)}
						<div class="status">
							${when(!this.isMandatory(), () => html`
								<button class='tools_button reset' @click="${this.resetDecision}"><span class="icon">${reset}</span></button>
							`)}
							<div class='icon indicator'>${this.isSatisfied() ? radioChecked : radio}</div>
						</div>
					</div>
				</div>
				<div class="search">
					<input @focus="${this.activate}" id="search" class="input" placeholder="Suche" type="text" @input=${this.onInput} .value=${this.search} autocomplete="off">
				</div>
				<div class="values">
					${repeat(this.filteredValues(this.values).slice(0, 200),
						(value) => value.id,
						(value) => html`
							<spc-choice-value-combo
								.attributeId=${this.attributeId}
								.value=${value}
								.hideWhenDisabled=${this.hideDisabledValues}
								.productData=${this.getProductDataForValue(value.id)}>
							</spc-choice-value-combo>
						`)}
				</div>
			</div>
		`;
	}
}
